<template>
	<!-- 级联题 -->
	<div @click="setEditIndex(index)">
		<p v-if="isBankViewTest" class="my-bank-tag">级联题</p>
		<el-row :gutter="10" class="question-box">
			<el-col v-if="!isBankViewTest" :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">{{ question.quesIndex + 1 }}</el-col>
			<el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title">
				<span style="lineHeight: 30px" v-if="isBankViewTest && question.questionsName">{{ question.questionsName }}</span>

				<TitleEditor
					:isTest="true"
					v-if="!isBankViewTest"
					class="outline-none"
					:qid="question.qid"
					:class="question.qid"
					:value="question.questionsName"
					@childValueChange="
						val => {
							question.questionsName = val;
						}
					"
				></TitleEditor>
			</el-col>
			<el-col class="setBtn-box" :xs="7" :sm="7" :md="7" :lg="7" :xl="7" v-if="!$route.query.index">
				<template>
					<el-dropdown v-if="!$route.query.bankId" @visible-change="getBankList" :hide-on-click="false" ref="bankDropdown" trigger="click">
						<span class="el-dropdown-link">
							<el-tooltip content="收藏到题库" placement="top" effect="light">
								<i v-if="question.isedit && !question.bqid" class="el-icon-star-off to-bank item"></i>
							</el-tooltip>
						</span>
						<el-dropdown-menu slot="dropdown">
							<div class="scroll-body" style="overflow-y: auto;" :style="{ maxHeight: isAddBank ? '102px' : '200px' }">
								<el-dropdown-item class="dropdown-item" v-for="item in bankList" :key="item.id">
									<span>{{ item.name }}</span>
									<el-button class="btn" size="mini" @click="addToBank(item.id)" type="text">添加</el-button>
								</el-dropdown-item>
								<el-dropdown-item
									disabled
									style="
									font-size: 12px;
									color: #ccc"
									class="dropdown-item"
									v-if="bankList.length == 0"
								>
									<span>暂无题库</span>
								</el-dropdown-item>
							</div>

							<el-dropdown-item v-if="isAddBank" divided style="text-align:center">
								<el-form :model="bankForm" ref="ValidateForm" style="margin-bottom: 0;" class="demo-ruleForm">
									<el-form-item prop="name" :rules="[{ required: true, message: '不能为空' }]">
										<el-input size="mini" v-model="bankForm.name"></el-input>
									</el-form-item>
									<el-form-item size="mini" style="text-align: right;margin-bottom: 0;">
										<el-button type="text" @click="addBank">创建</el-button>
										<el-button type="text" @click="cancelAddBank">取消</el-button>
									</el-form-item>
								</el-form>
							</el-dropdown-item>

							<el-dropdown-item divided style="text-align:center">
								<el-button @click="isAddBank = true" style="width:178px;" icon="el-icon-circle-plus-outline" type="text">新建题库</el-button>
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>

					<el-tooltip content="取消收藏" placement="top" effect="light">
						<i class="form-bank item el-icon-star-on" v-if="question.isedit && question.bqid" @click="delFormBank"></i>
					</el-tooltip>
				</template>
				<template v-if="!isBankViewTest">
					<div @click="() => $emit('jumpshow', question)">
						<el-badge v-if="question.logicalSettings.num" :value="question.logicalSettings.num" class="item"><i class="el-icon-share"></i></el-badge>
					</div>
					<i class="el-icon-rank item drag-handle"></i>
					<i v-if="question.isedit" class="zxwj-iconfont zxwj-icon-fuzhi item" @click="copyClick(question)"></i>
					<i class="el-icon-delete delete" v-if="question.isedit" @click="questiondel(question.qid)"></i>
				</template>
			</el-col>
		</el-row>

		<el-row :gutter="10" style="margin-top: 12px !important;margin-bottom: 14px">
			<div style="margin-left: 50px;">
				<!-- <el-cascader v-model="value" :options="question.optionList" @change="handleChange">
				</el-cascader> -->
				<el-select :popper-append-to-body="false" class="selectLeft" v-model="levelOneId" placeholder="请选择" @change="oneChange">
					<el-option :label="question.optionPlaceholder1" value=" "></el-option>
					<el-option v-for="item in question.optionList" :key="item.id" :label="item.label" :value="item.value + '_' + item.id"></el-option>
				</el-select>

				<el-select :popper-append-to-body="false" class="selectLeft" v-model="levelTwoId" placeholder="请选择" @change="twoChange">
					<el-option :label="question.optionPlaceholder2" value=" "></el-option>
					<el-option v-for="item in levelTwoOptionList" :key="item.id" :label="item.label" :value="item.value + '_' + item.id"></el-option>
				</el-select> 

				<el-select :popper-append-to-body="false" v-if="levelThreeOptionList.length > 0" class="selectLeft" v-model="levelThreeId" placeholder="请选择" @change="ThreeChange">
					<el-option :label="question.optionPlaceholder3" value=" "></el-option>
					<el-option v-for="item in levelThreeOptionList" :key="item.id" :label="item.label" :value="item.value + '_' + item.id"></el-option>
				</el-select>

				<el-select :popper-append-to-body="false" v-if="levelFourOptionList.length > 0" class="selectLeft" v-model="levelFourId" placeholder="请选择">
					<el-option :label="question.optionPlaceholder4" value=" "></el-option>
					<el-option v-for="item in levelFourOptionList" :key="item.id" :label="item.label" :value="item.value + '_' + item.id"></el-option>
				</el-select>
				<div style="margin-top: 10px;" v-if="inputShow"><el-input style="width: 200px;" v-model="input" placeholder="请输入内容"></el-input></div>
			</div>
		</el-row>

		<el-row :gutter="10" style="margin-top: 12px !important" v-if="question.isedit && !isBankViewTest">
			<el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16" class="el_item_option item_container_title" style="margin-left: 50px">
				<i class="el-icon-edit el-icon-common" @click="openEditOptions">编辑选项</i>
				<!-- <i class="el-icon-folder-add el-icon-common" @click="upladData">导入选项</i> -->
			</el-col>
		</el-row>
		<cascadeCascadingEditOptions :question="question" ref="cascadeCascadingEditOptions"></cascadeCascadingEditOptions>
		<uploadData ref="uploadData" @uploadDataOk="uploadDataOk"></uploadData>
	</div>
</template>

<script>
import TitleEditor from '@/components/titleEditor/titleEditor.vue';
import cascadeCascadingEditOptions from './cascadeCascadingEditOptions/index';
import uploadData from './cascadeCascadingEditOptions/uploadData';
export default {
	components: {
		TitleEditor,
		cascadeCascadingEditOptions,
		uploadData
	},
	props: {
		question: {},
		editIndex: { type: Number, default: 0 },
		index: { type: Number, default: 0 },
		isExistPage: { type: Boolean, default: false },
		editOptionIndex: { type: String, default: '0_0' },
		questionList: {
			type: Array,
			default: () => []
		},
		// 管理题库时查看试题 只可以删除
		isBankViewTest: {
			type: Boolean,
			default: false
		},
		bankList: {
			type: Array,
			default: () => {
				return [];
			}
		}
	},
	data() {
		return {
			inputShow: false,
			input: '',
			levelTwoOptionList: [],
			levelThreeOptionList: [],
			levelFourOptionList: [],
			levelOneId: '',
			levelTwoId: '',
			levelThreeId: '',
			levelOneIdText: '',
			levelTwoIdText: '',
			levelThreeIdText: '',
			levelFourId: '',
			// 题库start
			isAddBank: false,
			bankForm: {
				isSystemBank: 0, // 我的题库
				name: '',
				type: '未分类',
				bankType: 1
			}
			// 题库end
		};
	},
	watch: {
		'question.questionsName':{
			handler(newV, oldV){
				if (newV !== oldV && this.question.bqid) {
					this.question.bqid = ''
				}
			},
			deep: true
		},
    	'question.optionList.length':{
			handler(newV, oldV){
				if (newV !== oldV && this.question.bqid) {
					this.question.bqid = ''
				}
			},
			deep: true
		},
	},
	created() {
		console.log('查询', this.question.optionList);
	},
	methods: {
		copyClick(question){
			this.$emit('questionCopy',question)
		},
		uploadDataOk(value) {
			console.log('查询', this.question);
			console.log('查询', value);
			this.question.optionList = value;
		},
		upladData() {
			this.$refs.uploadData.openUpload();
		},
		oneChange(value) {
			this.levelOneId = value.split('_')[0];
			this.levelOneIdText = value.split('_')[1];
			this.levelTwoId = '';
			this.levelTwoOptionList = [];
			this.levelThreeId = '';
			this.levelThreeOptionList = [];
			this.levelFourId = '';
			this.levelFourOptionList = [];
			this.question.optionList.forEach(item => {
				if (this.levelOneIdText == item.id) {
					this.levelTwoOptionList = item.children;
				}
				if (item.type == 2) {
					this.inputShow = ture;
				}
			});
		},
		twoChange(value) {
			this.levelTwoId = value.split('_')[0];
			this.levelTwoIdText = value.split('_')[1];
			this.levelThreeId = '';
			this.levelThreeOptionList = [];
			this.levelFourId = '';
			this.levelFourOptionList = [];
			this.question.optionList.forEach(item => {
				if (this.levelOneIdText == item.id) {
					item.children.forEach(item2 => {
						if (this.levelTwoIdText == item2.id) {
							this.levelThreeOptionList = item2.children;
						}
						if (item2.type == 2) {
							this.inputShow = ture;
						}
					});
				}
			});
		},
		ThreeChange(value) {
			console.log(value);
			this.levelThreeId = value.split('_')[0];
			this.levelThreeIdText = value.split('_')[1];
			this.levelFourId = '';
			this.levelFourOptionList = [];
			this.question.optionList.forEach(item => {
				if (this.levelOneIdText == item.id) {
					item.children.forEach(item2 => {
						if (this.levelTwoIdText == item2.id) {
							item2.children.forEach(item3 => {
								if (this.levelThreeIdText == item3.id) {
									this.levelFourOptionList = item3.children;
								}
								if (item3.type == 2) {
									this.inputShow = ture;
								}
							});
						}
					});
				}
			});
		},
		handleChange(value) {
			console.log(value);
		},
		openEditOptions() {
			this.$refs.cascadeCascadingEditOptions.dialogVisible = true;
		},
		// 题库start
		getBankList(e) {
			if (e) {
				this.$emit('getBankList');
			}
		},
		setEditIndex(index) {
			this.$emit('setEditIndex', index);
		},
		addToBank(id) {
			this.$refs.bankDropdown.hide();
			this.$emit('addToBank', this.question, id);
			console.log(this.question);
		},
		delFormBank() {
			this.$emit('delFormBank', this.question);
		},
		addBank() {
			this.$refs.ValidateForm.validate(valid => {
				if (valid) {
					this.isAddBank = true;
					this.$emit('addBank', this.bankForm, this.question.qid);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
			// this.$refs.bankDropdown.show()
		},
		cancelAddBank() {
			this.isAddBank = false;
			this.bankForm.name = '';
		},
		questiondel(id, associated) {
			this.$emit('questiondel', id, undefined, associated);
		}
	}
};
</script>

<style lang="scss" scoped>
.selectLeft {
	width: 120px;
	margin-left: 10px;
}
.selectLeft:first-child {
	margin-left: 0px;
}
.el_item_option {
	line-height: 40px;
	height: 44px;
}
.el-icon-common {
	margin-right: 23px;
	font-size: 16px !important;
	line-height: 40px !important;
	color: cornflowerblue;
	cursor: pointer;
}
</style>
